import { render, staticRenderFns } from "./index.vue?vue&type=template&id=114ec266&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/views/extranet/isvIntroduction/index.scss?vue&type=style&index=0&id=114ec266&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114ec266",
  null
  
)

export default component.exports